
		<input
			type="text"
			autocomplete="off"
			class="form-control"
			[placeholder]="format"
			name="dp"
			[(ngModel)]="model"
			ngbDatepicker
			#datepicker="ngbDatepicker"
			(click)="onInputClick()"
			(input)="onInput($event)"
			(dateSelect)="onDateSelection($event)"
			[disabled]="disabled"
		>
		
		<span
			class="fa fa-calendar-alt"
			aria-hidden="true"
			(click)="onClick()"
		></span>
	